var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import { Button } from "@riseart/common";
import { Form } from "../form/Form";
import { FormItem } from "../item/Item";
import { FormItemsRenderer } from "./Items";
import { hasErrors } from "../utils/helpers";
var FormRenderer = /* @__PURE__ */ function(_Component) {
  function FormRenderer2(props) {
    var _this;
    _classCallCheck(this, FormRenderer2);
    _this = _callSuper(this, FormRenderer2, [props]);
    _defineProperty(_this, "formRef", /* @__PURE__ */ React.createRef());
    _this.bindMethods();
    return _this;
  }
  __name(FormRenderer2, "FormRenderer");
  _inherits(FormRenderer2, _Component);
  return _createClass(FormRenderer2, [{
    key: "handleSubmit",
    value: /* @__PURE__ */ __name(function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props, onSubmit = _this$props.onSubmit, preventDefault = _this$props.preventDefault;
      if (typeof onSubmit !== "function") {
        throw new Error("[Form Builder] Invalid onSubmit prop provided for form submit handling");
      }
      if (this.formRef.current && this.formRef.current.validateFields) {
        this.formRef.current.validateFields().then(function(values) {
          return onSubmit(values, _this2.formRef.current);
        });
      }
      if (preventDefault) {
        return false;
      }
    }, "handleSubmit")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleSubmit = this.handleSubmit.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this3 = this;
      var _this$props2 = this.props, className = _this$props2.className, settings = _this$props2.settings, fields = _this$props2.fields, submitActionLabel = _this$props2.submitActionLabel, intl = _this$props2.intl, initialValues = _this$props2.initialValues, actionWrapperClassName = _this$props2.actionWrapperClassName, buttonProps = _this$props2.buttonProps, additionalButton = _this$props2.additionalButton, disableSubmitOnValidationError = _this$props2.disableSubmitOnValidationError, children = _this$props2.children, customData = _this$props2.customData;
      return /* @__PURE__ */ React.createElement(Form, _extends({
        ref: this.formRef,
        className
      }, settings, {
        onFinish: this.handleSubmit
      }), fields && fields.length ? /* @__PURE__ */ React.createElement(FormItemsRenderer, {
        layout: settings.layout,
        fields,
        initialValues,
        customData,
        intl,
        form: this.formRef.current
      }) : null, children && typeof children === "function" ? children(_objectSpread(_objectSpread({}, this.props), {}, {
        form: this.formRef.current
      })) : children, submitActionLabel || additionalButton ? /* @__PURE__ */ React.createElement(FormItem, {
        className: actionWrapperClassName,
        shouldUpdate: true
      }, function() {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, additionalButton && typeof additionalButton === "function" ? additionalButton(_objectSpread(_objectSpread({}, _this3.props), {}, {
          form: _this3.formRef.current
        })) : null, submitActionLabel ? /* @__PURE__ */ React.createElement(Button, _extends({
          type: "primary",
          size: "default",
          width: "container",
          htmlType: "submit",
          disabled: disableSubmitOnValidationError && _this3.formRef.current && _this3.formRef.current.getFieldsError ? hasErrors(_this3.formRef.current.getFieldsError()) : false
        }, buttonProps), submitActionLabel) : null);
      }) : null);
    }, "render")
  }]);
}(Component);
_defineProperty(FormRenderer, "defaultProps", {
  initialValues: {},
  onSubmit: null,
  preventDefault: true,
  buttonProps: null,
  additionalButton: null,
  actionWrapperClassName: null,
  disableSubmitOnValidationError: false
});
var FormBuilder = FormRenderer;
export {
  FormBuilder
};
